import { IAttrValue } from "@multiweb/types/contracts";
import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { FileEditStatus } from "../../../../UI/UI/FileMenu";
import { ItemTemplate } from "../ItemTemplate";

export class FileTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        const value = await this._getJoinData(dataSet, this.parentColumn);
        item.querySelector(".name").textContent = value;

        if (value.trim().length === 0) {
            FileTemplate.updateStatus(item, FileEditStatus.empty);
        }
    }

    public static updateStatus(fileElement: HTMLElement, status: FileEditStatus, progressValue?: number, fileName: string = ""): void {
        fileElement.classList.remove(FileEditStatus[FileEditStatus.download], FileEditStatus[FileEditStatus.error], FileEditStatus[FileEditStatus.uploading], FileEditStatus[FileEditStatus.empty]);
        fileElement.classList.add(FileEditStatus[status]);

        const progressElement = fileElement.querySelector(".progress") as HTMLElement;
        if (progressValue != null)
            progressElement.style.width = progressValue + "%";
        else
            progressElement.style.width = "100%";

        if (fileName)
            fileElement.querySelector(".name").textContent = fileName;
    }

    protected override _createContentElement(): HTMLElement {
        const innerElement = createElement({ classes: "fileTemplate", attrs: { "data-attrname": this.parentColumn.attrName } });
        const progressElement = createElement({ classes: "progress" });
        const spanElement = createElement({ type: "span", classes: "name" });
        const downloadBtn = createElement({ classes: ["inline-btn", "Icon", FileEditStatus[FileEditStatus.download]] });

        downloadBtn.addEventListener("click", () => {
            this.parentColumn.callEvent("downloadRequest", {
                id: downloadBtn.closest(".DataRow").getAttribute("datakey"),
                column: this.parentColumn,
            });
        });

        innerElement.appendChild(progressElement);
        innerElement.appendChild(spanElement);
        innerElement.appendChild(downloadBtn);

        return innerElement;
    }
}
